import React, { useState, useEffect } from "react";
import Slider from "../page/Slider";
import CourseCard from "../page/CourseCard";
import { Link , useNavigate} from "react-router-dom";
import BASE_URL from "../../config/config";
import "../../css/Home.css";
import FAQSection from "../template/FAQSection";
const Home = () => {
  const navigate = useNavigate();
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const goToCourseDetail = (courseId) => {
    navigate(`/courses/${courseId}`);
  };
  // دریافت دوره‌ها
  useEffect(() => {
    const fetchCourses = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await fetch(
          `${BASE_URL}/public/courses?page=1&limit=6`
        );
        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}));
          throw new Error(errorData.message || `HTTP ${response.status}`);
        }
        const data = await response.json();
        setCourses(data.data?.courses || []);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchCourses();
  }, []);

   // محاسبه قیمت نهایی با تخفیف
  const calculateFinalPrice = (price, discount) => {    
    const originalPrice = parseFloat(price) || 0;
    const discountPercent = parseFloat(discount) || 0;
    return originalPrice - (originalPrice * discountPercent) / 100;
  };
  
  return (
    <div>
      <Slider />

      {/* Intro & Services Section */}
      <section className="py-16 px-5 bg-white">
        <div className="container mx-auto text-center max-w-6xl">
          {/* Shoaar Saazemani */}
          <h1
            className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-[#140a46] mb-6 leading-tight tracking-tight transition-transform duration-300 hover:scale-105"
            style={{
              background: "linear-gradient(135deg, #00a0dc 0%, #140a46 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              backgroundClip: "text",
            }}
          >
            هوش جدید ، راهی به سوی زندگی جدید
          </h1>

          {/* Intro Text */}
          <p className="text-base sm:text-lg text-gray-600 mb-10 leading-relaxed max-w-3xl mx-auto font-light">
            در سایت هوش جدید، ما سه نوع خدمات حرفه‌ای ارائه می‌دهیم:
          </p>

          {/* Services Grid */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
            {/* Service 1: Programming & Web Design */}
            <div className="group p-6 rounded-2xl bg-gradient-to-b from-[#00a0dc]/5 to-white shadow-lg hover:shadow-2xl border border-[#00a0dc]/15 transition-all duration-300 transform hover:-translate-y-2 hover:scale-105">
              <h3 className="text-lg sm:text-xl font-bold text-[#00a0dc] mb-4 whitespace-nowrap overflow-hidden text-ellipsis">
                خدمات برنامه‌نویسی و توسعه وب
              </h3>
              <p className="text-gray-600 leading-relaxed text-sm md:text-base opacity-90 group-hover:opacity-100 transition-opacity duration-300">
                توسعه وب‌سایت‌ها و اپلیکیشن‌های مدرن با فناوری‌های روز دنیا:
                فرانت‌اند با React و Next.js، بک‌اند با Node.js و Express، و
                پایگاه داده با MongoDB، MySQL، PostgreSQL و Redis. همچنین طراحی
                و پیاده‌سازی حرفه‌ای APIهای RESTful و GraphQL، و توسعه سایت‌های
                پویا و سریع با وردپرس (ووکامرس). از ایده تا راه‌اندازی، همراه
                شما هستیم.
              </p>
            </div>

            {/* Service 2: Programming & AI Education */}
            <div className="group p-6 rounded-2xl bg-gradient-to-b from-[#00a0dc]/5 to-white shadow-lg hover:shadow-2xl border border-[#00a0dc]/15 transition-all duration-300 transform hover:-translate-y-2 hover:scale-105">
              <h3 className="text-lg sm:text-xl font-bold text-[#00a0dc] mb-4 whitespace-nowrap overflow-hidden text-ellipsis">
                خدمات آموزشی
              </h3>
              <p className="text-gray-600 leading-relaxed text-sm md:text-base opacity-90 group-hover:opacity-100 transition-opacity duration-300">
                آموزش تخصصی برنامه‌نویسی وب با جاوااسکریپت (React، Node.js)،
                آموزش پایتون برای توسعه و علم داده، دوره‌های کاربردی وردپرس و
                آشنایی با مفاهیم هوش مصنوعی. دوره‌های ما پروژه‌محور، عملی و از
                صفر تا حرفه‌ای هستند — مناسب برای مبتدیان و علاقه‌مندان به ورود
                به بازار کار فناوری.
              </p>
            </div>

            {/* Service 3: Graphic Design */}
            <div className="group p-6 rounded-2xl bg-gradient-to-b from-[#00a0dc]/5 to-white shadow-lg hover:shadow-2xl border border-[#00a0dc]/15 transition-all duration-300 transform hover:-translate-y-2 hover:scale-105">
              <h3 className="text-lg sm:text-xl font-bold text-[#00a0dc] mb-4 whitespace-nowrap overflow-hidden text-ellipsis">
                خدمات گرافیکی
              </h3>
              <p className="text-gray-600 leading-relaxed text-sm md:text-base opacity-90 group-hover:opacity-100 transition-opacity duration-300">
                طراحی حرفه‌ای لوگو، ایجاد موکاپ، تولید موشن گرافیک و ادیت
                پیشرفته محتوای ویدیویی برای ریلز اینستاگرام و یوتیوب. همچنین
                طراحی تیزر تبلیغاتی، بنر و محتوای شبکه‌های اجتماعی با کیفیت بالا
                و سرعت بالا.
              </p>
            </div>
          </div>

          {/* Final CTA Paragraph */}
          <div className="mt-12 md:mt-14">
            <p className="text-gray-700 leading-relaxed text-base sm:text-lg max-w-4xl mx-auto font-medium tracking-wide">
              تیم ما آماده است تا با مشاوره‌های حرفه‌ای، شما را در هر مرحله از
              یادگیری و توسعه همراهی کند. به ما بپیوندید و آینده‌ای روشن و
              هوشمندانه بسازید!
            </p>
          </div>
        </div>
      </section>
      {/* Learning Path */}
      <section className="py-20 bg-light">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-2xl md:text-3xl font-bold mb-6 text-primary">
            از React تا Node.js و وردپرس!
          </h2>
          <h3 className="Learning-Path-h3 text-3xl md:text-5xl font-bold mb-8 gradient-text leading-tight">
            مسیر یادگیری
            <br />
            توسعه وب مدرن
          </h3>
          <p className="text-gray-600 text-lg max-w-4xl mx-auto leading-relaxed">
            با هوش جدید، یادگیری را از پایه شروع کنید: طراحی وب‌سایت با وردپرس،
            ساخت اپلیکیشن‌های مدرن با React و Node.js، و گام بعدی با هوش مصنوعی.
            ما مسیری ، کاربردی و پروژه‌محور برای شما طراحی کرده‌ایم تا بتوانید
            در دنیای توسعه وب موفق شوید.
          </p>
        </div>
      </section>

      {/* Technologies Section */}
      <section className="py-16 px-5 bg-white">
        <div className="container mx-auto text-center">
          <h2 className="text-3xl font-bold text-dark mb-4">
            تکنولوژی‌هایی که با آن‌ها کار می‌کنیم
          </h2>
          <p className="text-gray-600 text-lg mb-10 max-w-3xl mx-auto">
            ما بر روی فناوری‌های مدرن و پرتقاضای بازار کار تمرکز داریم. با هوش
            جدید، مثل یک توسعه‌دهنده حرفه‌ای یاد بگیرید و پروژه بسازید.
          </p>

          {/* Tech Icons */}
          <div className="flex flex-wrap justify-center gap-10 md:gap-16 text-4xl lg:text-5xl opacity-80 hover:opacity-100 transition-opacity duration-300">
            <div className="text-center">
              <span className="block transform hover:scale-110 transition-transform">
                ⚛️
              </span>
              <span className="text-sm md:text-base font-medium text-gray-700 mt-2 block">
                React
              </span>
            </div>
            <div className="text-center">
              <span className="block transform hover:scale-110 transition-transform">
                🟢
              </span>
              <span className="text-sm md:text-base font-medium text-gray-700 mt-2 block">
                Node.js
              </span>
            </div>
            <div className="text-center">
              <span className="block transform hover:scale-110 transition-transform">
                📜
              </span>
              <span className="text-sm md:text-base font-medium text-gray-700 mt-2 block">
                JavaScript
              </span>
            </div>
            <div className="text-center">
              <span className="block transform hover:scale-110 transition-transform">
                ⓔ
              </span>
              <span className="text-sm md:text-base font-medium text-gray-700 mt-2 block">
                Express
              </span>
            </div>
            <div className="text-center">
              <span className="block transform hover:scale-110 transition-transform">
                🟠
              </span>
              <span className="text-sm md:text-base font-medium text-gray-700 mt-2 block">
                MongoDB
              </span>
            </div>
            <div className="text-center">
              <span className="block transform hover:scale-110 transition-transform">
                🟣
              </span>
              <span className="text-sm md:text-base font-medium text-gray-700 mt-2 block">
                WordPress
              </span>
            </div>
            <div className="text-center">
              <span className="block transform hover:scale-110 transition-transform">
                🐍
              </span>
              <span className="text-sm md:text-base font-medium text-gray-700 mt-2 block">
                Python
              </span>
            </div>
            <div className="text-center">
              <span className="block transform hover:scale-110 transition-transform">
                🤖
              </span>
              <span className="text-sm md:text-base font-medium text-gray-700 mt-2 block">
                AI
              </span>
            </div>
          </div>
        </div>
      </section>

      {/* Course List Home */}
      <section className="mt-4 bg-white mb-4">
        <h1 className="text-3xl font-bold text-center mb-6">
          دوره‌های پیشنهادی
        </h1>

        {loading && (
          <div className="flex justify-center py-10">
            <div className="loader"></div>
          </div>
        )}

        {error && <p className="text-red-500 text-center py-6">{error}</p>}

        {!loading && !error && courses.length > 0 && (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {courses.slice(0, 3).map((course) => (
              <CourseCard
                key={course.id}
                course={{
                  id: course.id,
                  title: course.title,
                  description: course.description,
                  level: course.level,
                  levelName:
                    course.level === "beginner"
                      ? "مقدماتی"
                      : course.level === "intermediate"
                        ? "متوسط"
                        : "پیشرفته",
                  price: course.price === "0" ? "رایگان" : course.price,
                  discount: course.discount || 0,
                    isFree: course.is_free || course.price === "0",
                    finalPrice:
                      parseFloat(course.discount) > 0
                        ? calculateFinalPrice(course.price, course.discount)
                        : null,
                  duration: course.duration || "نامشخص",
                  students: course.enrollment_count || "0",
                  rating: course.rating || "0",
                  icon: course.cover_pic || "📚",
                  isFree: course.price === "0",
                }}
                onClick={() => goToCourseDetail(course.id)}
              />
            ))}
          </div>
        )}

        {!loading && !error && courses.length === 0 && (
          <p className="text-center py-8 text-gray-500">
            هیچ دوره‌ای یافت نشد.
          </p>
        )}

        {courses.length > 0 && (
          <div className="text-center mt-12">
            <button className="btn-primary px-8 py-4 rounded-xl font-bold text-lg transition-all shadow-lg">
              <Link to="/courses"> 📚 مشاهده دوره‌های بیشتر</Link>
            </button>
          </div>
        )}
      </section>

      {/* Features */}
      <section className="py-20 bg-light mt-5">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold gradient-text mb-4">
              چرا با هوش جدید توسعه وب یاد بگیریم؟
            </h2>
            <p className="text-gray-600 text-lg">
              آموزش مدرن، عملی و پروژه‌محور با فناوری‌های روز دنیای توسعه وب
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* Feature 1: Modern Stack */}
            <div className="text-center group">
              <div className="w-24 h-24 bg-primary rounded-2xl flex items-center justify-center mx-auto mb-6 shadow-lg group-hover:scale-110 transition-transform">
                <span className="text-white text-3xl">⚛️</span>
              </div>
              <h3 className="text-lg font-bold text-dark mb-3">
                آموزش React و Node.js
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                از مفاهیم پایه تا ساخت اپلیکیشن‌های فول‌استک مدرن با React و
                Node.js — دقیقاً همان فناوری‌هایی که شرکت‌ها امروز استفاده
                می‌کنند.
              </p>
            </div>

            {/* Feature 2: Project-Based Learning */}
            <div className="text-center group">
              <div className="w-24 h-24 bg-dark rounded-2xl flex items-center justify-center mx-auto mb-6 shadow-lg group-hover:scale-110 transition-transform">
                <span className="text-white text-3xl">🎯</span>
              </div>
              <h3 className="text-lg font-bold text-dark mb-3">
                پروژه‌های واقعی و عملی
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                هر دوره با ساخت یک پروژه واقعی تمام می‌شود: از وب‌سایت شخصی تا
                سیستم‌های مدیریت و APIهای پیچیده.
              </p>
            </div>

            {/* Feature 3: Full-Stack Focus */}
            <div className="text-center group">
              <div className="w-24 h-24 bg-primary rounded-2xl flex items-center justify-center mx-auto mb-6 shadow-lg group-hover:scale-110 transition-transform">
                <span className="text-white text-3xl">🔗</span>
              </div>
              <h3 className="text-lg font-bold text-dark mb-3">
                توسعه فول‌استک مدرن
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                یاد بگیرید چگونه Frontend با React و Backend با Node.js را به هم
                متصل کنید و یک اپلیکیشن کامل بسازید.
              </p>
            </div>

            {/* Feature 4: Real-World Tools */}
            <div className="text-center group">
              <div className="w-24 h-24 bg-dark rounded-2xl flex items-center justify-center mx-auto mb-6 shadow-lg group-hover:scale-110 transition-transform">
                <span className="text-white text-3xl">🛠️</span>
              </div>
              <h3 className="text-lg font-bold text-dark mb-3">
                ابزارهای مورد استفاده در صنعت
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Git, REST API, JWT, MongoDB, Express — همه چیز را مثل یک
                توسعه‌دهنده حرفه‌ای کار کنید.
              </p>
            </div>
          </div>
        </div>
      </section>
      <div className="mt-10 mb-5">
        <FAQSection />
      </div>
      {/* CTA */}
      <section className="hero-bg py-20">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6 leading-tight">
            آماده شروع یادگیری هستید؟
          </h2>
          <p className="text-white text-xl mb-12 opacity-95 leading-relaxed">
            همین الان شروع کنید و مسیر حرفه‌ای خود را با هوش مصنوعی بسازید
          </p>
          <div className="flex flex-col sm:flex-row gap-6 justify-center">
            <button className="btn-primary px-5 py-4 rounded-xl font-bold text-xl transition-all shadow-xl">
              <Link to="/courses"> مشاهده همه دوره‌ها</Link>
            </button>
            <button className="btn-secondary border-2 text-white px-5 py-4 rounded-xl font-bold text-xl hover:text-primary transition-all shadow-xl">
              <Link to="/signup">ثبت نام</Link>
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
